export default function extractSummaryExpectedAt(response) {
  const etaString = response.headers?.['note-summary-eta-seconds'];
  const eta = etaString ? parseFloat(etaString) : null;
  return eta && eta > 0 ? Date.now() + (eta * 1000) : null;
}
